import React, { Component } from "react"

//#region  modules
import { nundefined } from "../../modules/utilities"
import { COLUMN, KIND } from "../../modules/constants"
import { createSearchRowData } from "./CreateSearchRowData"
import createHeadersData from "./CreateHeadersData"
import createFootersData from "./CreateFootersData"
import initStats from "../tables/InitStats"
//#endregion modules

//#region components
import NumerableTable from "../NumerableTable"
import FavouritesMessage from "../searchCompanies/FavouritesMessage"
import NoDataMessage from "../searchCompanies/NoDataMessage"
//#endregion components

class SearchResults extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.searchString !== this.props.searchString || nextProps.searchResults !== this.props.searchResults
  }

  render() {
    // console.log('SearchResults this.props:', this.props)
    const { checkboxes, handleClickFavouriteIcon, handleSelect, nsmSearchString, tableAnalysis, searchResults, tabIndex } = this.props
    const { filter, items, kind } = searchResults
    const isSearch = KIND.someEqual(KIND.SEARCH, kind)
    const isFavourites = KIND.someEqual(KIND.FAVOURITE, kind)
    const stats = initStats()

    const columns = {
      [KIND.SEARCH.COMPANIES]: {},
      [KIND.LSE.ROLES.COMMITTEES]: {
        [COLUMN.AGE]: true,
        [COLUMN.SEX]: true,
        [COLUMN.TENURE]: true,
      },
      [KIND.LSE.ROLES.BOARD]: {},
    }

    // columns[KIND.LSE.ROLES.COMMITTEES][COLUMN.SEX] = checkboxes[HOOK.SEX] > 1 // for testing: don't show column if only male checked
    // columns[KIND.LSE.ROLES.COMMITTEES][COLUMN.TENURE] = checkboxes[HOOK.SEX] < 2 // for testing: show column if only male checked

    const tableProps = { ...this.props, columns, items, kind, stats }

    return (
      <React.Fragment>
        {(items && items.length === 0 && !nundefined(kind)) && !isFavourites &&
          <NoDataMessage
            filter={filter}
            kind={kind}
            nsmSearchString={nsmSearchString}
            searchString={searchResults.searchString}
            tabIndex={tabIndex}
            totalResults={searchResults.totalResults}
          />
        }

        {isFavourites &&
          items && items.length === 0 &&
          <FavouritesMessage favouriteKind={kind} />
        }

        {items && items.length > 0 &&
          (<NumerableTable
            table={{
              ...this.props,
              handleOnClick: row => handleSelect({ ...row, kind }),
              kind,
              headers: createHeadersData({ ...tableProps }),
              rows: createSearchRowData({ ...tableProps }),
              footers: tableAnalysis ? createFootersData({ ...tableProps }) : null,
              handleClickFavouriteIcon: row => handleClickFavouriteIcon(row),
              headerStyle: isSearch ? "" : "favourites",
            }}
          ></NumerableTable>)
        }

      </React.Fragment>
    )
  }
}

export default SearchResults